import { gql } from '@apollo/client'

export const GET_LABEL_BY_ID = gql`
  query ($id: String) {
    getLabelById(id: $id) {
      alias
      name
      country_codes
      max_radio_stations
      units {
        id
        alias
        name
      }
      id
    }
  }
`
